import Meta from '@/components/common/Meta'

import ShipLuggageInternationallyPage from '@/v2/components/pages/landing-pages/ship-luggage-internationally-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/ship-luggage-internationally-page'

interface ShipLuggageInternationallyPageProps {}

const Page: React.FC<ShipLuggageInternationallyPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.ship_luggage_internationally.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.ship_luggage_internationally?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.ship_luggage_internationally?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <ShipLuggageInternationallyPage />
    </>
  )
}

export default Page
